import {
  LOAD_TIME_SLOT_LIST,
  LOAD_TIME_SLOT_LIST_SUCCESS,
  LOAD_TIME_SLOT_LIST_ERROR,
  HOLD_BOOKING_SLOT,
  HOLD_BOOKING_SLOT_SUCCESS,
  HOLD_BOOKING_SLOT_ERROR,
  RELEASE_BOOKING_SLOT,
  RELEASE_BOOKING_SLOT_SUCCESS,
  RELEASE_BOOKING_SLOT_ERROR,
  BOOK_APPOINTMENT,
  BOOK_APPOINTMENT_SUCCESS,
  BOOK_APPOINTMENT_ERROR,
  SAVE_SELECTED_BOOKING_SLOT,
  SAVE_SELECTED_BOOKING_SLOT_SUCCESS,
  SAVE_SELECTED_BOOKING_SLOT_ERROR,
  CLEAR_SELECTED_BOOKING_SLOT,
  CLEAR_SELECTED_BOOKING_SLOT_SUCCESS,
  CLEAR_SELECTED_BOOKING_SLOT_ERROR,
  RESET_CURRENT_HOLDING_SLOT,
  RESET_TIME_SLOT_DATA,
} from '../type';
import update from 'immutability-helper';

import { handleActions } from 'redux-actions';

import { initialState } from './initialize-state';

const newBookingReducer = handleActions(
  new Map([
    [
      LOAD_TIME_SLOT_LIST,
      state => {
        return update(state, {
          loadingStatus: {
            timeSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      LOAD_TIME_SLOT_LIST_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            timeSlotLoading: { $set: false },
          },
          timeSlotData: {
            $set: action.payload,
          },
        });
      },
    ],
    [
      LOAD_TIME_SLOT_LIST_ERROR,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            timeSlotLoading: { $set: false },
          },
          error: { $set: action.payload },
        });
      },
    ],
    //Load patient detail
    [
      HOLD_BOOKING_SLOT,
      state => {
        return update(state, {
          loadingStatus: {
            timeSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      HOLD_BOOKING_SLOT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            timeSlotLoading: { $set: false },
          },
          currentHoldingSlot: { $set: action.payload },
        });
      },
    ],
    [
      HOLD_BOOKING_SLOT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            timeSlotLoading: { $set: false },
          },
        });
      },
    ],

    //Create patient
    [
      RELEASE_BOOKING_SLOT,
      state => {
        return update(state, {
          loadingStatus: {
            releaseBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      RELEASE_BOOKING_SLOT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            releaseBookingSlotLoading: { $set: false },
          },
        });
      },
    ],
    [
      RELEASE_BOOKING_SLOT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            releaseBookingSlotLoading: { $set: false },
          },
        });
      },
    ],

    [
      BOOK_APPOINTMENT,
      state => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: true },
          },
        });
      },
    ],
    [
      BOOK_APPOINTMENT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: false },
          },
        });
      },
    ],
    [
      BOOK_APPOINTMENT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: false },
          },
        });
      },
    ],
    [
      BOOK_APPOINTMENT,
      state => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: true },
          },
        });
      },
    ],
    [
      BOOK_APPOINTMENT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: false },
          },
        });
      },
    ],
    [
      BOOK_APPOINTMENT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            bookAppointmentLoading: { $set: false },
          },
        });
      },
    ],

    [
      SAVE_SELECTED_BOOKING_SLOT,
      state => {
        return update(state, {
          loadingStatus: {
            saveSelectedBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      SAVE_SELECTED_BOOKING_SLOT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            saveSelectedBookingSlotLoading: { $set: false },
          },
          selectedBookingSlot: { $set: action.payload },
        });
      },
    ],
    [
      SAVE_SELECTED_BOOKING_SLOT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            saveSelectedBookingSlotLoading: { $set: false },
          },
        });
      },
    ],

    [
      CLEAR_SELECTED_BOOKING_SLOT,
      state => {
        return update(state, {
          loadingStatus: {
            clearSelectedBookingSlotLoading: { $set: true },
          },
        });
      },
    ],
    [
      CLEAR_SELECTED_BOOKING_SLOT_SUCCESS,
      (state, action) => {
        return update(state, {
          loadingStatus: {
            clearSelectedBookingSlotLoading: { $set: false },
          },
          selectedBookingSlot: { $set: {} },
        });
      },
    ],
    [
      CLEAR_SELECTED_BOOKING_SLOT_ERROR,
      state => {
        return update(state, {
          loadingStatus: {
            clearSelectedBookingSlotLoading: { $set: false },
          },
        });
      },
    ],
    [
      RESET_CURRENT_HOLDING_SLOT,
      (state, action) => {
        return update(state, {
          currentHoldingSlot: { $set: {} },
        });
      },
    ],
    [
      RESET_TIME_SLOT_DATA,
      state => {
        return update(state, {
          timeSlotData: {
            $set: {},
          },
        });
      },
    ],
  ]),
  initialState,
);
export default newBookingReducer;
